// extracted by mini-css-extract-plugin
export var Cta = "CardWithIcon-module--Cta--VIwzi";
export var button = "CardWithIcon-module--button--UPL4R";
export var card = "CardWithIcon-module--card--BBEDf";
export var description = "CardWithIcon-module--description--IbRVw";
export var icon = "CardWithIcon-module--icon--RH6yV";
export var limitWidthOnLargeScreens = "CardWithIcon-module--limitWidthOnLargeScreens--2PwR1";
export var title = "CardWithIcon-module--title--Aq+pf";
export var upperSection = "CardWithIcon-module--upperSection--pNQ4B";